import { render } from "./LandingPageV2.vue?vue&type=template&id=2e81eef8"
import script from "./LandingPageV2.vue?vue&type=script&lang=js"
export * from "./LandingPageV2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__